export default __webpack_public_path__ + "v1.18.25/static/media/LibreDataShare_Japanese.504fe043.svg";